export enum HalfState {
    BeforeFirstHalf = 1,
    FirstHalf = 2,
    DuringHalfTime = 3,
    SecondHalf = 4,
    AfterSecondHalf = 5
}